import type { ReactNode } from 'react';
import { Children, isValidElement } from 'react';
import { Typography } from './index';

export const wrapTextChildrenWithTypography = (children: ReactNode | ReactNode[]) =>
  Children.map(children, (child) => (isValidElement(child) ? child : <Typography as="span">{child}</Typography>));
